
/**
 * Este modelo representa un DTO de la tabla PARAMETROS
 */
export class ParametrosModel {
    descripcion: String;
    estado: String;
    fechaCreacion: Date;
    fechaModificacion: Date;
    modulo: String;
    nombre: String;
    usuarioModificacion: String;
    valor: String;
}
